import { Link as RouterLink } from 'react-router-dom'
import {
  Box,
  Container,
  Heading,
  Text,
  SimpleGrid,
  VStack,
  Image,
  Button,
} from '@chakra-ui/react'

const StepCard = ({ number, title, description, capiroteImage, bgColor }) => (
  <VStack
    gap={6}
    p={8}
    bg={bgColor}
    rounded="3xl"
    position="relative"
    overflow="visible"
    minH="400px"
    justify="space-between"
  >
    <Box
      position="absolute"
      top={-4}
      left={6}
      bg="white"
      w={12}
      h={12}
      rounded="full"
      display="flex"
      alignItems="center"
      justifyContent="center"
      boxShadow="lg"
      fontWeight="bold"
      fontSize="xl"
      color="purple.600"
    >
      {number}
    </Box>

    <Image
      src={capiroteImage}
      alt=""
      maxW="180px"
      mt={8}
      css={{ filter: 'drop-shadow(0 10px 20px rgba(0,0,0,0.1))' }}
    />

    <VStack gap={3} textAlign="center">
      <Heading size="md" color="gray.800">
        {title}
      </Heading>
      <Text color="gray.600" fontSize="md" lineHeight="tall">
        {description}
      </Text>
    </VStack>
  </VStack>
)

const STEPS = [
  {
    number: 1,
    title: 'Crea tu cuenta',
    description:
      'Regístrate como banda en minutos y completa tu perfil con datos de la banda.',
    capiroteImage: '/capirote1.png',
    bgColor: 'purple.50',
  },
  {
    number: 2,
    title: 'Valida tu cuenta',
    description:
      'Completa los datos obligatorios de tu perfil, genera el código de validación y envíalo por mensaje directo a nuestras redes. Así confirmamos que sois una banda real. Te da seguridad a ti y a quien te contacte. Mientras revisamos (suele ser en 48 horas), el perfil no es visible en Comunidad.',
    capiroteImage: '/capirote2.png',
    bgColor: 'green.50',
  },
  {
    number: 3,
    title: 'Gestiona tu banda',
    description:
      'Plantilla de músicos, archivo musical, ensayos, actuaciones, encuestas y tu propia web. Todo el día a día de la agrupación, en Cadencya.',
    capiroteImage: '/capirote3.png',
    bgColor: 'red.50',
  },
]

const HowItWorks = () => (
  <Box id="como-funciona" bg="white" py={{ base: 16, md: 24 }} data-landing="como-funciona">
    <Container maxW="7xl">
      <VStack gap={{ base: 12, md: 16 }}>
        <VStack gap={4} textAlign="center">
          <Heading
            as="h2"
            fontSize={{ base: '3xl', md: '4xl', lg: '5xl' }}
            fontWeight="800"
            color="gray.800"
          >
            ¿Cómo funciona?
          </Heading>
          <Text fontSize={{ base: 'lg', md: 'xl' }} color="gray.600" maxW="2xl">
            Tres pasos para poner en marcha tu perfil.
          </Text>
        </VStack>

        <SimpleGrid columns={{ base: 1, md: 3 }} gap={{ base: 8, md: 6, lg: 8 }} w="full">
          {STEPS.map((step) => (
            <StepCard key={step.number} {...step} />
          ))}
        </SimpleGrid>

        <Button variant="outline" rounded="full" size="lg" px={8} asChild>
          <RouterLink to="/como-funciona">Ver la guía completa</RouterLink>
        </Button>
      </VStack>
    </Container>
  </Box>
)

export default HowItWorks
